import { render } from "./OrderSourceIndexPage.vue?vue&type=template&id=0953629e"
import script from "./OrderSourceIndexPage.vue?vue&type=script&lang=js"
export * from "./OrderSourceIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__